<div class="relative">
    <app-table-widget
        #widget
        [dataLoader]="dataLoaderWidgetDeviceFailures"
        [title]="'Latest warnings and errors'"
        [pageSize]="5"
        [columns]="columns"
    >
    </app-table-widget>
</div>
